import { MemberCheck } from '@pass-frontend/data-access/common/edge';

const BASE_FITNESS_KEY = 'auth:fitness-network:';

const COMMERCIAL_CLASSIC_FITNESS_KEY = `${BASE_FITNESS_KEY}commercial-core`;
const COMMERCIAL_STANDARD_FITNESS_KEY = `${BASE_FITNESS_KEY}commercial-premium-low`;
const COMMERCIAL_PREMIUM_FITNESS_KEY = `${BASE_FITNESS_KEY}commercial-premium-mid`;
const COMMERCIAL_ELITE_FITNESS_KEY = `${BASE_FITNESS_KEY}commercial-premium-high`;

const GOVERNMENT_CORE_FITNESS_KEY = `${BASE_FITNESS_KEY}medicare-core`;
const GOVERNMENT_PREMIUM_FITNESS_KEY = `${BASE_FITNESS_KEY}medicare-premium`;
const GOVERNMENT_YMCA_FITNESS_KEY = `${BASE_FITNESS_KEY}premium-ymcas`;
const GOVERNMENT_VA_YMCA_FITNESS_KEY = `${BASE_FITNESS_KEY}va-premium-ymcas`;
const GOVERNMENT_DEPENDENT_FITNESS_KEY = `${BASE_FITNESS_KEY}government-dependent`;

const FITNESS_KEYS_MAPPING = {
  [COMMERCIAL_CLASSIC_FITNESS_KEY]: [COMMERCIAL_CLASSIC_FITNESS_KEY],
  [COMMERCIAL_STANDARD_FITNESS_KEY]: [
    COMMERCIAL_CLASSIC_FITNESS_KEY,
    COMMERCIAL_STANDARD_FITNESS_KEY,
  ],
  [COMMERCIAL_PREMIUM_FITNESS_KEY]: [
    COMMERCIAL_CLASSIC_FITNESS_KEY,
    COMMERCIAL_STANDARD_FITNESS_KEY,
    COMMERCIAL_PREMIUM_FITNESS_KEY,
  ],
  [COMMERCIAL_ELITE_FITNESS_KEY]: [
    COMMERCIAL_CLASSIC_FITNESS_KEY,
    COMMERCIAL_STANDARD_FITNESS_KEY,
    COMMERCIAL_PREMIUM_FITNESS_KEY,
    COMMERCIAL_ELITE_FITNESS_KEY,
  ],
  [GOVERNMENT_CORE_FITNESS_KEY]: [GOVERNMENT_CORE_FITNESS_KEY],
  [GOVERNMENT_PREMIUM_FITNESS_KEY]: [
    GOVERNMENT_CORE_FITNESS_KEY,
    GOVERNMENT_PREMIUM_FITNESS_KEY,
  ],
  [GOVERNMENT_YMCA_FITNESS_KEY]: [
    GOVERNMENT_CORE_FITNESS_KEY,
    GOVERNMENT_YMCA_FITNESS_KEY,
  ],
  [GOVERNMENT_VA_YMCA_FITNESS_KEY]: [
    GOVERNMENT_CORE_FITNESS_KEY,
    GOVERNMENT_VA_YMCA_FITNESS_KEY,
  ],
  [GOVERNMENT_DEPENDENT_FITNESS_KEY]: [GOVERNMENT_DEPENDENT_FITNESS_KEY],
};

export const checkMemberAccessToGym = (
  gymAuthTagKeys: string[],
  memberTags: string[] | undefined,
  product: string,
): boolean => {
  const memberFitnessTags = memberTags?.filter((tag) =>
    tag.startsWith(BASE_FITNESS_KEY),
  );

  if (
    !memberFitnessTags ||
    memberFitnessTags.length === 0 ||
    gymAuthTagKeys.length === 0
  ) {
    return false;
  }

  if (
    product &&
    product.toLowerCase() === 'renewactive' &&
    gymAuthTagKeys.includes('auth:client-exclusion:renewactive')
  ) {
    return false;
  }

  let memberAccessibleGymTags: string[] = [];
  memberFitnessTags.forEach((tag) => {
    memberAccessibleGymTags = [
      ...memberAccessibleGymTags,
      ...(FITNESS_KEYS_MAPPING[tag] || []),
    ];
  });
  // Removing duplicate tags.
  memberAccessibleGymTags = [...new Set(memberAccessibleGymTags)];

  for (const gymAuthKey of gymAuthTagKeys) {
    if (memberAccessibleGymTags.includes(gymAuthKey)) {
      return true;
    }
  }

  return false;
};

export const isGovernmentDependentMemberCheck = (
  memberDetails: MemberCheck,
): boolean =>
  !memberDetails?.tags?.includes(
    'auth:one-pass:government-family-membership',
  ) &&
  memberDetails?.tags?.includes('auth:fitness-network:government-dependent');
